let _data = 0;

const StepStore = {
  set: item => _data = item,
  get: () => _data
}

Object.freeze(StepStore);
export default StepStore;